import React, { useEffect, useState } from 'react';

const SummaryMetricsWidget = ({ view }) => {
    const [metrics, setMetrics] = useState([]);
    const [loading, setLoading] = useState(false);

    const colorMap = {
        purple: {
          bg: 'bg-purple-50',
          border: 'border-purple-200',
          text: 'text-purple-600',
        },
        green: {
          bg: 'bg-green-50',
          border: 'border-green-200',
          text: 'text-green-600',
        },
        blue: {
          bg: 'bg-blue-50',
          border: 'border-blue-200',
          text: 'text-blue-600',
        },
        orange: {
          bg: 'bg-orange-50',
          border: 'border-orange-200',
          text: 'text-orange-600',
        },
        teal: {
          bg: 'bg-teal-50',
          border: 'border-teal-200',
          text: 'text-teal-600',
        },
        indigo: {
          bg: 'bg-indigo-50',
          border: 'border-indigo-200',
          text: 'text-indigo-600',
        },
      };

      const LoadingCard = () => (
        <div className="bg-gray-100 border border-gray-200 p-4 rounded-lg shadow-sm flex items-center justify-center h-32">
          <div className="animate-spin rounded-full h-6 w-6 border-2 border-gray-400 border-t-transparent"></div>
        </div>
      );

  useEffect(() => {
    const fetchData = async () => {
      if (view === 'start') {
        setLoading(true);
        try {
          const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/summary-conversations`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`
              }
          });
          const data = await res.json();
          setMetrics([
            {
              label: 'Conversations',
              value: data.conversationsStarted,
              description: 'Total conversations initiated...',
              color: 'purple',
            },
            {
              label: 'Reports',
              value: data.conversationsCompleted,
              description: 'Conversations completed...',
              color: 'green',
            },
            {
              label: 'Custom Scenarios',
              value: { total: data.customScenariosCreated },
              description: 'Scenarios you’ve created...',
              color: 'blue',
            },
          ]);
        } catch (err) {
          console.error('Error fetching conversation summary:', err);
        } finally {
            setLoading(false);
        }
      } else if (view === 'progress') {
        setLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/progress-metrics`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
            });
            const data = await res.json();
            setMetrics([
            {
                label: 'Weekly Streak',
                value: data.weeklyStreak,
                description: 'Consecutive active weeks of conversations started...',
                color: 'orange',
            },
            {
                label: 'Conversation Length',
                value: {
                    total: data.averageConversationLength,
                    longest: data.longestConversationLength,
                    shortest: data.shortestConversationLength
                  },
                description: 'Average dialogue length per conversation...',
                color: 'blue',
            },
            {
                label: 'Weekly Conversations',
                value: data.averageConversationsPerWeek,
                description: 'Average conversations per week...',
                color: 'green',
            }
            ]);
        } catch (err) {
            console.error('Error fetching progress metrics:', err);
        } finally {
            setLoading(false);
        }
      }
    };

    fetchData();
  }, [view]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
            {loading
                ? Array.from({ length: 3 }).map((_, idx) => <LoadingCard key={idx} />)
                : metrics.map(({ label, value, description, color }) => (
            <div
                key={label}
                className={`border ${colorMap[color].bg} ${colorMap[color].border} p-4 rounded-lg shadow-sm grid grid-cols-2 grid-rows-2 gap-2`}
                >
                {/* Top Left: Title + Description */}
                <div className="flex flex-col items-start justify-start col-span-1 row-span-1">
                    <div className="text-2xl font-semibold text-gray-700">{label}</div>
                    {description && <div className="text-sm text-gray-500">{description}</div>}
                </div>

                {/* Top Right: Total Value */}
                <div className="flex items-start justify-end col-span-1 row-span-1">
                    <div className={`${colorMap[color].text} text-4xl font-bold`}>
                    {typeof value === 'object' ? value.total : value}
                    </div>
                </div>

                {/* Bottom Left: Custom or Longest */}
                {typeof value === 'object' && value.custom != null && (
                    <div className="flex flex-col items-center justify-center col-span-1 row-span-1">
                        <div className={`text-sm font-medium ${colorMap[color].text}`}>Custom</div>
                        <div className={`text-xl font-bold ${colorMap[color].text}`}>{value.custom}</div>
                    </div>
                    )}

                    {typeof value === 'object' && value.longest != null && (
                    <div className="flex flex-col items-center justify-center col-span-1 row-span-1">
                        <div className={`text-sm font-medium ${colorMap[color].text}`}>Longest</div>
                        <div className={`text-xl font-bold ${colorMap[color].text}`}>{value.longest}</div>
                    </div>
                    )}

                    {/* Bottom Right: Static or Shortest */}
                    {typeof value === 'object' && value.static != null && (
                    <div className="flex flex-col items-center justify-center col-span-1 row-span-1">
                        <div className={`text-sm font-medium ${colorMap[color].text}`}>Static</div>
                        <div className={`text-xl font-bold ${colorMap[color].text}`}>{value.static}</div>
                    </div>
                    )}

                    {typeof value === 'object' && value.shortest != null && (
                    <div className="flex flex-col items-center justify-center col-span-1 row-span-1">
                        <div className={`text-sm font-medium ${colorMap[color].text}`}>Shortest</div>
                        <div className={`text-xl font-bold ${colorMap[color].text}`}>{value.shortest}</div>
                    </div>
                )}
            </div>
        ))}
    </div>

  );
};

export default SummaryMetricsWidget;
